export const favoritesEligibility = {
    NO_FAVORITES: 'N',
    ONLY_PAID_FAVORITES: 'P',
    ONLY_UNPAID_FAVORITES: 'U',
    ALL_MEDIA_ELIGIBLE: 'A'
}